import { useUserStore } from '../../stores/use-user-store';
import { ROLES } from '../../hooks/use-role';
import { SUPPORT_SECTION } from './constants';

const useSupportAccess = () => {
  const { user } = useUserStore();
  const sections = user?.sections;
  const permissionsReady = Array.isArray(sections);
  const section = permissionsReady ? sections.find((item) => item?.section === SUPPORT_SECTION) : null;
  const isEngineer = user?.role === ROLES.ENGINEER;
  const engineerId = user?.engineer_id ?? (isEngineer ? user?.id : null);

  return {
    canRead: permissionsReady ? Boolean(section?.read) : true,
    canWrite: permissionsReady ? Boolean(section?.write) : true,
    engineerId: engineerId ?? null,
  };
};

export default useSupportAccess;
